import { FC } from 'react';
import cn from 'classnames';

import DesktopNavBarWrapper from 'components/Header/Desktop/DesktopNavBarWrapper';
import MainLogo from 'components/Header/MiddleBar/MainLogo';
import { SearchBar } from 'entities/SearchBar';

import styles from './styles.module.scss';

import type { INavigationContainerDesktop } from '../config/declarations';

const NavigationContainerDesktop: FC<INavigationContainerDesktop> = ({
  nav,
  logo,
  search,
  isSimplifiedHeader,
}) => {
  if (!nav && !logo) {
    return null;
  }

  return (
    <section className={styles.wrapper}>
      <div className={cn(
        styles.navContainer,
        {
          [styles.simplified]: isSimplifiedHeader,
          [styles.common]: !isSimplifiedHeader,
        },
      )}
      >
        <MainLogo
          mainLogo={logo!}
          isMobileView={false}
          className={isSimplifiedHeader ? styles.logo : ''}
        />
        {!isSimplifiedHeader
          && <SearchBar search={search} />}
        {!isSimplifiedHeader
          && <DesktopNavBarWrapper navBar={nav} />}
      </div>
    </section>
  );
};

export default NavigationContainerDesktop;
